(()=>{
const $=(s,r=document)=>r.querySelector(s),$$=(s,r=document)=>[...r.querySelectorAll(s)];
const T=window.theme||{routes:{root:'/',cart:'/cart',add:'/cart/add',change:'/cart/change'}};
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const money=c=>{try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:T.currency||'USD'}).format(c/100)}catch(e){return (c/100).toFixed(2)}};
const parse=h=>new DOMParser().parseFromString(h,'text/html');
const ARROW='<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
const X='<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>';

/* reveal on scroll */
const io='IntersectionObserver' in window?new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}}),{threshold:.1,rootMargin:'0px 0px -30px 0px'}):null;
const reveal=(root=document)=>$$('[data-reveal]:not(.is-in)',root).forEach(el=>io?io.observe(el):el.classList.add('is-in'));
setTimeout(()=>$$('[data-reveal]:not(.is-in)').forEach(el=>{const r=el.getBoundingClientRect();if(r.top<innerHeight)el.classList.add('is-in')}),2500);

/* toast */
let toastEl;const toast=m=>{if(!toastEl){toastEl=document.createElement('div');toastEl.className='toast';toastEl.setAttribute('role','status');document.body.appendChild(toastEl)}toastEl.textContent=m;toastEl.classList.add('is-on');clearTimeout(toastEl._t);toastEl._t=setTimeout(()=>toastEl.classList.remove('is-on'),3200)};

/* fly-to-cart animation */
function fly(img){
  const cart=$('.header__cart');if(!img||!cart||reduce||!img.getBoundingClientRect)return;
  const a=img.getBoundingClientRect(),b=cart.getBoundingClientRect();if(!a.width)return;
  const c=img.cloneNode();c.removeAttribute('srcset');c.removeAttribute('sizes');c.className='';c.alt='';
  Object.assign(c.style,{position:'fixed',left:a.left+'px',top:a.top+'px',width:a.width+'px',height:a.height+'px',objectFit:'cover',borderRadius:'14px',zIndex:500,pointerEvents:'none',margin:0,transform:'none',inset:'auto'});
  c.style.left=a.left+'px';c.style.top=a.top+'px';document.body.appendChild(c);
  const dx=b.left+b.width/2-(a.left+a.width/2),dy=b.top+b.height/2-(a.top+a.height/2);
  const an=c.animate([{transform:'translate(0,0) scale(1)',opacity:1},{transform:`translate(${dx*.55}px,${dy*.55-60}px) scale(.5)`,opacity:.95,offset:.55},{transform:`translate(${dx}px,${dy}px) scale(.06)`,opacity:.3}],{duration:800,easing:'cubic-bezier(.5,0,.2,1)'});
  an.onfinish=()=>c.remove();
}

/* cart drawer */
const drawer=()=>$('#CartDrawer');
const openCart=()=>{const d=drawer();if(!d)return;d.classList.add('is-open','intro');clearTimeout(d._t);d._t=setTimeout(()=>d.classList.remove('intro'),1800);d.setAttribute('aria-hidden','false');document.body.classList.add('no-scroll');setTimeout(()=>$('.drawer__close',d)?.focus(),60)};
const closeCart=()=>{const d=drawer();if(!d)return;d.classList.remove('is-open');d.setAttribute('aria-hidden','true');document.body.classList.remove('no-scroll')};

async function refresh(open){
  const [s,c]=await Promise.all([fetch(T.routes.root+'?sections=cart-drawer').then(r=>r.json()),fetch(T.routes.cart+'.js').then(r=>r.json())]);
  const cur=$('#CartDrawer .drawer__inner'),nxt=$('.drawer__inner',parse(s['cart-drawer']));
  if(cur&&nxt)cur.innerHTML=nxt.innerHTML;
  $$('.js-cart-count').forEach(el=>{el.textContent=c.item_count;el.hidden=c.item_count===0;el.classList.remove('bump');void el.offsetWidth;el.classList.add('bump')});
  const mc=$('[data-main-cart]');
  if(mc){const h=await fetch(T.routes.cart+'?section_id=main-cart').then(r=>r.text());const n=$('[data-main-cart]',parse(h));if(n)mc.innerHTML=n.innerHTML}
  if(open&&!mc)setTimeout(openCart,reduce?0:450);
}
async function add(body,btn,imgEl){
  btn&&btn.classList.add('is-loading');
  try{
    const isFD=body instanceof FormData;
    const r=await fetch(T.routes.add+'.js',{method:'POST',headers:isFD?{Accept:'application/json'}:{'Content-Type':'application/json',Accept:'application/json'},body:isFD?body:JSON.stringify(body)});
    const j=await r.json();
    if(!r.ok){toast(j.description||j.message||'Could not add to cart');return}
    fly(imgEl);confetti(btn);const cb=$('.header__cart');if(cb){cb.classList.remove('wiggle');void cb.offsetWidth;cb.classList.add('wiggle');setTimeout(()=>cb.classList.remove('wiggle'),800)}
    await refresh(true);
    if(btn){btn.classList.add('is-added');setTimeout(()=>btn.classList.remove('is-added'),1800)}
  }catch(e){toast('Something went wrong. Please try again.')}
  finally{btn&&btn.classList.remove('is-loading')}
}
async function change(line,qty){
  try{
    const r=await fetch(T.routes.change+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:+line,quantity:+qty})});
    if(!r.ok){const j=await r.json();toast(j.description||'Could not update cart')}
    await refresh(false);
  }catch(e){toast('Something went wrong.')}
}

document.addEventListener('click',e=>{
  const o=e.target.closest('[data-cart-open]');
  if(o&&drawer()&&!$('[data-main-cart]')){e.preventDefault();o.classList.remove('wiggle');void o.offsetWidth;o.classList.add('wiggle');openCart();return}
  if(e.target.closest('[data-cart-close]')){closeCart();return}
  const qa=e.target.closest('[data-quick-add]');
  if(qa){e.preventDefault();const src=qa.closest('.card')?.querySelector('.card__img')||qa.closest('.upsell__item')?.querySelector('img')||qa.closest('.spot')?.querySelector('.spot__media img');add({id:qa.dataset.quickAdd,quantity:1},qa,src);return}
  const ch=e.target.closest('[data-line-change]');
  if(ch){e.preventDefault();const li=ch.closest('.line-item');if(ch.dataset.qty==='0'&&li&&!reduce){li.classList.add('is-removing');setTimeout(()=>change(ch.dataset.line,ch.dataset.qty),340)}else change(ch.dataset.line,ch.dataset.qty);return}
  if(e.target.closest('[data-menu-toggle]')){$('[data-mobile-menu]').classList.toggle('is-open')}
});

/* header: hide on scroll down, show on scroll up */
const header=$('[data-header]');
if(header){let last=scrollY;addEventListener('scroll',()=>{const y=scrollY;header.classList.toggle('is-scrolled',y>8);
  const menuOpen=$('[data-mobile-menu]')?.classList.contains('is-open');
  header.classList.toggle('is-hidden',y>last&&y>260&&!menuOpen);last=y},{passive:true})}
/* hero parallax (subtle, vertical only) */
const frame=$('.hero__frame');
if(frame&&!reduce)addEventListener('scroll',()=>{if(scrollY<900)frame.style.transform=`translateY(${scrollY*.06}px) rotate(1.5deg)`},{passive:true});
/* announcement rotator */
const msgs=$$('.announce__msg');
if(msgs.length>1){let i=0;setInterval(()=>{msgs[i].classList.remove('is-active');i=(i+1)%msgs.length;msgs[i].classList.add('is-active')},4000)}
/* sort */
const sort=$('[data-sort]');
if(sort)sort.addEventListener('change',()=>{const u=new URL(location.href);u.searchParams.set('sort_by',sort.value);u.searchParams.delete('page');location.href=u});

/* countdown (real end date only) */
function initCountdowns(root=document){$$('[data-countdown]',root).forEach(el=>{
  if(el._on)return;el._on=1;
  const end=new Date(el.dataset.countdown).getTime();
  if(isNaN(end)){el.hidden=true;return}
  const set=(s,v)=>{const n=$(s,el);if(n)n.textContent=String(v).padStart(2,'0')};
  const tick=()=>{const d=Math.max(0,end-Date.now());set('[data-d]',Math.floor(d/864e5));set('[data-h]',Math.floor(d/36e5%24));set('[data-m]',Math.floor(d/6e4%60));set('[data-s]',Math.floor(d/1e3%60));if(d===0){el.hidden=true;clearInterval(t)}};
  const t=setInterval(tick,1000);tick();
})}

/* lightbox: opens on click; click the image again to zoom */
let lb,lbUrls=[],lbI=0;
function lbShow(i){
  lbI=(i+lbUrls.length)%lbUrls.length;const img=$('.lb__img',lb);
  img.classList.remove('is-zoomed');img.src=lbUrls[lbI];
  $('.lb__count',lb).textContent=lbUrls.length>1?(lbI+1)+' / '+lbUrls.length:'';
  $$('.lb__nav',lb).forEach(b=>b.hidden=lbUrls.length<2);
}
function lbClose(){if(!lb)return;lb.classList.remove('is-open');document.body.classList.remove('no-scroll');$('.lb__img',lb).classList.remove('is-zoomed')}
function openLB(urls,i){
  if(!lb){
    lb=document.createElement('div');lb.className='lb';lb.setAttribute('role','dialog');lb.setAttribute('aria-label','Image viewer');
    lb.innerHTML='<p class="lb__hint">Click the image to zoom</p><button type="button" class="lb__btn lb__close" aria-label="Close">'+X+'</button><button type="button" class="lb__btn lb__nav lb__prev" aria-label="Previous">'+ARROW+'</button><div class="lb__stage"><img class="lb__img" alt=""></div><button type="button" class="lb__btn lb__nav lb__next" aria-label="Next">'+ARROW+'</button><p class="lb__count"></p>';
    document.body.appendChild(lb);
    const img=$('.lb__img',lb),stage=$('.lb__stage',lb);
    const origin=e=>{const r=stage.getBoundingClientRect();img.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%'};
    img.addEventListener('click',e=>{e.stopPropagation();if(img.classList.contains('is-zoomed'))img.classList.remove('is-zoomed');else{origin(e);img.classList.add('is-zoomed')}});
    stage.addEventListener('mousemove',e=>{if(img.classList.contains('is-zoomed'))origin(e)});
    lb.addEventListener('click',e=>{if(e.target===lb||e.target.closest('.lb__close'))lbClose();else if(e.target.closest('.lb__prev'))lbShow(lbI-1);else if(e.target.closest('.lb__next'))lbShow(lbI+1)});
    document.addEventListener('keydown',e=>{if(!lb.classList.contains('is-open'))return;if(e.key==='Escape')lbClose();if(e.key==='ArrowLeft')lbShow(lbI-1);if(e.key==='ArrowRight')lbShow(lbI+1)});
  }
  lbUrls=urls;lbShow(i);lb.classList.add('is-open');document.body.classList.add('no-scroll');
}
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeCart()});

/* product page */
const ordinal=d=>{const n=d.getDate(),v=n%100,suf=(v>=11&&v<=13)?'th':['th','st','nd','rd','th','th','th','th','th','th'][n%10];return d.toLocaleDateString(document.documentElement.lang||'en',{month:'short'})+' '+n+suf};
function addBusinessDays(n){const d=new Date();let a=0;while(a<n){d.setDate(d.getDate()+1);if(d.getDay()%6)a++}return d}
function initProduct(sec){
  if(sec._on)return;sec._on=1;
  const variants=JSON.parse($('[data-variants]',sec).textContent);
  const vById=id=>variants.find(v=>v.id===+id);
  const form=$('form',sec),idIn=$('[data-variant-id]',form),atc=$('[data-atc]',sec),label=$('[data-atc-label]',sec);
  const stock=$('[data-stock]',sec),low=+sec.dataset.low||0,hasBundle=sec.hasAttribute('data-has-bundle');
  const stickySel=$('[data-sticky-select]',sec);

  // order tracker
  const mn=+sec.dataset.min||7,mx=+sec.dataset.max||14,pr=+sec.dataset.process||3;
  const t0=$('[data-t0]',sec),t1=$('[data-t1]',sec),t2=$('[data-t2]',sec);
  if(t0)t0.textContent=ordinal(new Date());
  if(t1)t1.textContent=ordinal(addBusinessDays(1))+' - '+ordinal(addBusinessDays(Math.max(1,pr)));
  if(t2)t2.textContent=ordinal(addBusinessDays(mn))+' - '+ordinal(addBusinessDays(mx));

  // gallery + dots
  const slides=$$('.gallery__slide',sec),thumbs=$$('.gallery__thumb',sec),dotsEl=$('[data-dots]',sec);
  let cur=Math.max(0,slides.findIndex(s=>s.classList.contains('is-active')));
  const dots=dotsEl?slides.map((_,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Image '+(i+1));b.addEventListener('click',e=>{e.stopPropagation();show(i)});dotsEl.appendChild(b);return b}):[];
  function show(i){if(!slides.length)return;cur=(i+slides.length)%slides.length;slides.forEach((s,k)=>s.classList.toggle('is-active',k===cur));thumbs.forEach((t,k)=>t.classList.toggle('is-active',k===cur));dots.forEach((d,k)=>d.classList.toggle('is-active',k===cur));const t=thumbs[cur];if(t&&t.parentElement&&t.parentElement.scrollTo)t.parentElement.scrollTo({left:t.offsetLeft-t.parentElement.clientWidth/2+t.clientWidth/2,behavior:'smooth'})}
  show(cur);
  thumbs.forEach((t,i)=>t.addEventListener('click',()=>show(i)));
  $('[data-gallery-prev]',sec)?.addEventListener('click',e=>{e.stopPropagation();show(cur-1)});
  $('[data-gallery-next]',sec)?.addEventListener('click',e=>{e.stopPropagation();show(cur+1)});
  $$('[data-strip]',sec).forEach(b=>b.addEventListener('click',()=>{const tr=$('[data-strip-track]',sec);tr.scrollBy({left:+b.dataset.strip*tr.clientWidth*.8,behavior:'smooth'})}));
  const stage=$('[data-stage]',sec);
  if(stage){
    stage.addEventListener('click',e=>{if(e.target.closest('.gallery__nav,.gallery__dots'))return;const urls=slides.map(s=>s.dataset.full).filter(Boolean);if(urls.length)openLB(urls,cur)});
    let x0=null;stage.addEventListener('touchstart',e=>x0=e.touches[0].clientX,{passive:true});
    stage.addEventListener('touchend',e=>{if(x0===null)return;const dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)show(cur+(dx<0?1:-1));x0=null},{passive:true});
  }

  // variants (pills)
  const selected=()=>$$('.opt',sec).map(f=>($('input:checked',f)||{}).value);
  const match=o=>variants.find(v=>v.options.every((x,i)=>x===o[i]));
  let primary=variants.find(v=>v.id===+idIn.value)||variants[0];

  // bundle tiers
  const tiers=$$('.tier',sec);let active=tiers.find(t=>$('input',t).checked)||tiers[0];
  const picks=t=>$$('select[data-pick]',t);
  const tierIds=t=>{const q=+t.dataset.qty,ps=picks(t),a=[];for(let i=0;i<q;i++)a.push(ps[i]?+ps[i].value:primary.id);return a};
  function recalc(){tiers.forEach(t=>{
    let sum=0,strike=0;tierIds(t).forEach(id=>{const v=vById(id)||primary;sum+=v.price;strike+=v.compare>v.price?v.compare:v.price});
    const d=+t.dataset.disc||0,total=Math.round(sum*(100-d)/100),q=+t.dataset.qty;
    const p=$('[data-tier-price]',t);if(p.textContent!==money(total)){p.textContent=money(total);p.classList.remove('flash');void p.offsetWidth;p.classList.add('flash')}
    const s=$('[data-tier-strike]',t);s.textContent=money(strike);s.hidden=!(strike>total);
    $('[data-each]',t).textContent=money(Math.round(total/q))+' each';
  })}
  tiers.forEach(t=>{$('input',t).addEventListener('change',()=>{active=t;tiers.forEach(x=>x.classList.toggle('is-active',x===t));recalc()});
    picks(t).forEach((sel,i)=>sel.addEventListener('change',()=>{sel._manual=1;
      if(i===0&&!hasMultiOpt()){/* first pick mirrors main selector */const v=vById(sel.value);if(v)setPrimary(v)}
      recalc()}))});
  const hasMultiOpt=()=>false;

  function setPills(v){$$('.opt',sec).forEach((f,i)=>$$('input',f).forEach(inp=>{inp.checked=inp.value===v.options[i]}))}
  function setPrimary(v){setPills(v);update(false)}

  function update(first){
    const opts=selected();const v=variants.length===1?variants[0]:match(opts);
    $$('.opt',sec).forEach((f,i)=>{const l=$('[data-opt-label]',f);if(l)l.textContent=opts[i]||'';
      $$('input',f).forEach(inp=>{const t=opts.slice();t[i]=inp.value;const m=match(t);inp.classList.toggle('is-unavailable',!m||!m.available)})});
    if(!v){atc.disabled=true;label.textContent='Unavailable';stock.hidden=true;return}
    primary=v;idIn.value=v.id;atc.disabled=!v.available;label.textContent=v.available?'Add to cart':'Sold out';
    const priceEl=$('[data-price]',sec);priceEl.textContent=money(v.price);
    $('[data-sticky-price]',sec).textContent=money(v.price);
    const sc=$('[data-sticky-compare]',sec);if(sc){sc.hidden=!(v.compare>v.price);sc.textContent=money(v.compare)}
    const sale=v.compare>v.price,cmp=$('[data-compare]',sec),sv=$('[data-save]',sec);
    cmp.hidden=!sale;sv.hidden=!sale;if(sale){cmp.textContent=money(v.compare);$('[data-save-text]',sv).textContent='SAVE '+Math.round((v.compare-v.price)*100/v.compare)+'%'}
    if(!first){priceEl.classList.remove('flash');void priceEl.offsetWidth;priceEl.classList.add('flash')}
    // keep untouched bundle pickers in sync with the main selection
    tiers.forEach(t=>picks(t).forEach(sel=>{if(!sel._manual||sel===picks(t)[0])sel.value=v.id}));
    if(stickySel)stickySel.value=v.id;
    if(v.available&&v.stock>0&&v.stock<=low){stock.hidden=false;stock.textContent='Hurry! Only '+v.stock+' left in stock.'}else stock.hidden=true;
    if(v.media){const i=slides.findIndex(s=>+s.dataset.media===v.media);if(i>-1)show(i)}
    const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
    recalc();
  }
  $$('.opt input',sec).forEach(i=>i.addEventListener('change',()=>update(false)));
  stickySel?.addEventListener('change',()=>{const v=vById(stickySel.value);if(v)setPrimary(v)});
  update(true);

  // qty (non-bundle products)
  const q=$('input[data-qty]',sec);
  $$('[data-qty-step]',sec).forEach(b=>b.addEventListener('click',()=>{q.value=Math.max(1,(+q.value||1)+ +b.dataset.qtyStep)}));

  // add to cart
  const img=()=>$('.gallery__slide.is-active img',sec);
  function submit(btn){
    if(atc.disabled)return;
    if(hasBundle&&active){const map={};tierIds(active).forEach(id=>map[id]=(map[id]||0)+1);add({items:Object.entries(map).map(([id,quantity])=>({id:+id,quantity}))},btn,img())}
    else add(new FormData(form),btn,img());
  }
  form.addEventListener('submit',e=>{e.preventDefault();submit(atc)});
  const sticky=$('[data-sticky]',sec);
  if(sticky&&'IntersectionObserver' in window){new IntersectionObserver(([en])=>sticky.classList.toggle('is-visible',!en.isIntersecting&&en.boundingClientRect.top<0)).observe(atc)}
  $('[data-sticky-btn]',sec)?.addEventListener('click',e=>submit(e.currentTarget));
}

/* review rotator */
function initRotators(root=document){$$('[data-rotator]',root).forEach(el=>{
  if(el._on)return;el._on=1;
  const sl=$$('.rot__slide',el),dt=$$('.rot__dots button',el);let i=0,t;
  const go=n=>{i=(n+sl.length)%sl.length;sl.forEach((s,k)=>s.classList.toggle('is-active',k===i));dt.forEach((d,k)=>d.classList.toggle('is-active',k===i))};
  dt.forEach((d,k)=>d.addEventListener('click',()=>{go(k);clearInterval(t)}));go(0);
  if(sl.length>1)t=setInterval(()=>go(i+1),5500);
})}

/* before/after slider */
function initCompare(root=document){$$('[data-compare]',root).forEach(el=>{
  if(el._on||!$('.cmp__range',el))return;el._on=1;
  const r=$('.cmp__range',el),set=v=>el.style.setProperty('--pos',v+'%');
  r.addEventListener('input',()=>set(r.value));set(50);
  if(!reduce&&'IntersectionObserver' in window){const o=new IntersectionObserver(([e])=>{if(!e.isIntersecting)return;o.disconnect();const t0=performance.now();(function f(t){const p=Math.min(1,(t-t0)/1800);const v=p<1?50+Math.sin(p*Math.PI*2)*30*(1-p*.4):50;r.value=v;set(v);if(p<1)requestAnimationFrame(f)})(t0)},{threshold:.6});o.observe(el)}
})}

/* back to top */
const toTop=$('[data-to-top]');
if(toTop){addEventListener('scroll',()=>toTop.classList.toggle('is-on',scrollY>700),{passive:true});toTop.addEventListener('click',()=>scrollTo({top:0,behavior:reduce?'auto':'smooth'}))}

/* related products */
async function loadRecs(el){
  if(el._on||!el.dataset.url||el.querySelector('.grid'))return;el._on=1;
  try{const h=await fetch(el.dataset.url).then(r=>r.text());const n=$('[data-recs]',parse(h));if(n&&n.innerHTML.trim()){el.innerHTML=n.innerHTML;reveal(el)}}catch(e){}
}


/* ---------- animation pass ---------- */
document.addEventListener('pointerdown',e=>{
  const b=e.target.closest('.btn,.footer__btn,.card__quick');if(!b||reduce||b.disabled)return;
  const r=b.getBoundingClientRect(),z=Math.max(r.width,r.height)*2,rp=document.createElement('span');rp.className='ripple';
  Object.assign(rp.style,{width:z+'px',height:z+'px',left:(e.clientX-r.left-z/2)+'px',top:(e.clientY-r.top-z/2)+'px'});
  b.appendChild(rp);setTimeout(()=>rp.remove(),750);
});
function confetti(el){
  if(!el||reduce||!el.getBoundingClientRect)return;
  const r=el.getBoundingClientRect(),cx=r.left+r.width/2,cy=r.top+r.height/2,cols=['#E8BB26','#12275A','#3B8CF7','#12B76A','#FFD43B'];
  for(let i=0;i<18;i++){
    const p=document.createElement('i');p.className='confetti';p.style.cssText='left:'+cx+'px;top:'+cy+'px;background:'+cols[i%cols.length];document.body.appendChild(p);
    const a=Math.random()*Math.PI*2,d=60+Math.random()*90;
    p.animate([{transform:'translate(0,0) scale(1) rotate(0)',opacity:1},{transform:'translate('+Math.cos(a)*d+'px,'+(Math.sin(a)*d-50)+'px) scale(.9) rotate('+Math.random()*540+'deg)',opacity:1,offset:.55},{transform:'translate('+Math.cos(a)*d*1.1+'px,'+(Math.sin(a)*d+70)+'px) scale(.4) rotate(720deg)',opacity:0}],{duration:900+Math.random()*400,easing:'cubic-bezier(.2,.7,.3,1)'}).onfinish=()=>p.remove();
  }
}
const esc=t=>t.replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
function splitTitles(root=document){
  if(reduce)return;
  $$('.section__title:not([data-split])',root).forEach(el=>{
    const t=el.textContent.trim();if(!t||el.children.length&&!el.querySelector('.w'))return;
    if(el.querySelector('.w'))return;
    el.setAttribute('aria-label',t);el.setAttribute('data-split','');
    el.innerHTML=t.split(/\s+/).map((w,i)=>'<span class="w" aria-hidden="true"><span style="--i:'+i+'">'+esc(w)+'</span></span>').join(' ');
    io?io.observe(el):el.classList.add('is-in');
  });
}
function countUps(root=document){
  $$('.stat__pct:not([data-cu])',root).forEach(el=>{
    el.dataset.cu=1;const to=parseInt(el.textContent)||0;if(reduce||!('IntersectionObserver' in window))return;el.textContent='0%';
    const ob=new IntersectionObserver(([e])=>{if(!e.isIntersecting)return;ob.disconnect();const t0=performance.now();
      (function f(t){const p=Math.min(1,(t-t0-300)/1500),q=Math.max(0,p);el.textContent=Math.round(to*(1-Math.pow(1-q,3)))+'%';if(p<1)requestAnimationFrame(f)})(t0)},{threshold:.6});
    ob.observe(el);
  });
}
if(!reduce){const bar=document.createElement('div');bar.className='scroll-progress';document.body.appendChild(bar);
  addEventListener('scroll',()=>{const h=document.documentElement.scrollHeight-innerHeight;bar.style.transform='scaleX('+(h>0?scrollY/h:0)+')'},{passive:true})}

/* slideshow banner */
function initSlides(root=document){$$('[data-slides]',root).forEach(el=>{
  if(el._on)return;el._on=1;
  const sl=$$('.slide',el),dt=$$('.slides__dots button',el),secs=+el.dataset.autoplay||0;let i=0,t;
  const go=n=>{i=(n+sl.length)%sl.length;sl.forEach((s,k)=>s.classList.toggle('is-active',k===i));dt.forEach((d,k)=>d.classList.toggle('is-active',k===i))};
  const start=()=>{clearInterval(t);if(secs&&sl.length>1&&!reduce)t=setInterval(()=>go(i+1),secs*1000)};
  dt.forEach((d,k)=>d.addEventListener('click',()=>{go(k);start()}));
  $('[data-prev]',el)?.addEventListener('click',()=>{go(i-1);start()});
  $('[data-next]',el)?.addEventListener('click',()=>{go(i+1);start()});
  el.addEventListener('mouseenter',()=>clearInterval(t));el.addEventListener('mouseleave',start);
  let x0=null;el.addEventListener('touchstart',e=>x0=e.touches[0].clientX,{passive:true});
  el.addEventListener('touchend',e=>{if(x0===null)return;const dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40){go(i+(dx<0?1:-1));start()}x0=null},{passive:true});
  go(0);start();
})}
/* dropdown nav + country selector */
document.addEventListener('click',e=>{
  const b=e.target.closest('.nav__link[aria-haspopup]');
  $$('.nav__item.open').forEach(n=>{if(!b||n!==b.parentElement){n.classList.remove('open');$('.nav__link',n).setAttribute('aria-expanded','false')}});
  if(b){const o=b.parentElement.classList.toggle('open');b.setAttribute('aria-expanded',o)}
});
document.addEventListener('change',e=>{if(e.target.matches&&e.target.matches('[data-loc]'))e.target.form.submit()});

function initAll(root=document){
  initSlides(root);splitTitles(root);countUps(root);
  $$('[data-product]',root).forEach(initProduct);
  $$('[data-recs]',root).forEach(loadRecs);
  initCountdowns(root);initRotators(root);initCompare(root);reveal(root);
}
initAll();
document.addEventListener('shopify:section:load',e=>initAll(e.target));
})();
